var React = require('react');

function PcInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"pc.inline"),React.createElement("g",{"id":"ba564e8b-bef2-41f9-a374-10896c9baf31","data-name":"Layer 2","key":1},React.createElement("g",{"id":"b6b444df-885e-4f81-be6b-6f79cbc61c91","data-name":"Layer 1"},React.createElement("g",{"id":"e3fbc29a-7382-4c9b-9d57-db6df321e6e1","data-name":"pc.inline"},[React.createElement("path",{"d":"M19.44,30v3.24m-11.34,0H30.78m7.29-5.81A2.5,2.5,0,0,1,35.64,30H3.24A2.5,2.5,0,0,1,.81,27.4v-24A2.5,2.5,0,0,1,3.24.81h32.4a2.5,2.5,0,0,1,2.43,2.57Z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62","key":0}),React.createElement("line",{"x1":"0.81","y1":"25.11","x2":"38.07","y2":"25.11","fill":"none","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"1.62","key":1})])))]);
}

PcInline.defaultProps = {"viewBox":"0 0 38.88 34.02"};

module.exports = PcInline;

PcInline.default = PcInline;
